/**
 * PostHog events related to payment dialogs.
 */
export const PAYMENT_DIALOG_EVENTS = {
  // Triggered when a user opens the payment dialog
  OPENED: 'payment_dialog_opened',
  // Triggered when a user closes the payment dialog
  CLOSED: 'payment_dialog_closed',
};

/**
 * PostHog events related to payment confirmations.
 */
export const PAYMENT_CONFIRMATION_EVENTS = {
  CLICKED: 'payment_confirmation_clicked',
};

/**
 * PostHog events related to payment success.
 */
export const PAYMENT_SUCCESS_EVENTS = {
  COMPLETED: 'payment_success_completed',
};

/**
 * PostHog events related to wallet connections.
 */
export const WALLET_CONNECTION_EVENTS = {
  /** Triggered when a user initiates a connection attempt for any wallet type. */
  INITIATED: 'wallet_connection_initiated',
  /** Triggered when a wallet connection attempt succeeds. */
  CONNECTED: 'wallet_connected',
  /** Triggered when a wallet connection attempt fails. */
  FAILED: 'wallet_connection_failed',
};
